module.exports = __webpack_public_path__ + "media/images/content/pic_bank-d673ce5baf7b62b3e0c1300bc93d4c0f.svg";